export default "__VITE_ASSET__xnptII89__"